import * as React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import PageViewTracker from 'ms-helpers/PageViewTracker';
import { SnowplowProvider } from 'ms-helpers/Snowplow/SnowplowProvider';
import FreeTextbooksErrorBoundary from 'ms-pages/FreeTextbooks/FreeTextbooksNotFoundPage/ErrorBoundary';
import {
  AnonymousEnvironmentProvider as EnvironmentProvider,
  hydrateRelayNetworkStore,
} from 'ms-utils/relay';

import FreeTextbooksApp from './FreeTextbooksApp';

// @ts-expect-error
// __RELAY_REHYDRATE__ is only set for this entypoint so must not be added
// to the global Window interface.
// Property is declared in: msproblem/templates/free_textbooks/page.html
const __RELAY_REHYDRATE__ = window.__RELAY_REHYDRATE__;

// @ts-expect-error
// Don't want to expose snowplow on the global Window interface
const snowplow = window.snowplow;

// CSS Rendered on the server needs to get hydrated back into the client
hydrateRelayNetworkStore(__RELAY_REHYDRATE__);

export default function FreeTextbooks() {
  return (
    <FreeTextbooksErrorBoundary>
      <EnvironmentProvider>
        <SnowplowProvider snowplow={snowplow}>
          <PageViewTracker />
          <BrowserRouter>
            <FreeTextbooksApp />
          </BrowserRouter>
        </SnowplowProvider>
      </EnvironmentProvider>
    </FreeTextbooksErrorBoundary>
  );
}

if (window.INIT) {
  window.INIT(FreeTextbooks, React, ReactDOM);
}
